<template>
	<nav
		v-if="breadcrumbsStore.items.length > 0"
		class="breadcrumbs"
		:aria-label="$t('global-breadcrumbs-label')"
	>
		<ol class="breadcrumbs-list">
			<li
				v-for="(item, index) in breadcrumbsStore.items"
				:key="index"
				class="breadcrumbs-item"
			>
				<ChevronRightIcon v-if="index > 0" class="breadcrumbs-icon" size="sm" />

				<RouterLink class="breadcrumbs-link" :to="item.to">
					{{ item.label }}
				</RouterLink>
			</li>
		</ol>

		<RouterLink
			v-if="parentItem"
			class="breadcrumbs-back breadcrumbs-link"
			:to="parentItem.to"
		>
			<ChevronLeftIcon size="sm" />
			{{ parentItem.label }}
		</RouterLink>
	</nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { RouteLocationNamedRaw } from 'vue-router'

import ChevronLeftIcon from '@/shared/icons/ChevronLeftIcon.vue'
import ChevronRightIcon from '@/shared/icons/ChevronRightIcon.vue'
import { useBreadcrumbsStore } from '@/shared/stores/breadcrumbs.ts'

const breadcrumbsStore = useBreadcrumbsStore()
const parentItem = computed(() => breadcrumbsStore.items.at(-2))

export interface BreadcrumbItem {
	label: string
	to: RouteLocationNamedRaw
}
</script>

<style scoped>
.breadcrumbs {
	font: var(--type-body-s);
	position: relative;

	/* Pull above sticky route title to avoid cropped focus outline. */
	z-index: var(--z-index-breadcrumbs);
}

.breadcrumbs-list,
.breadcrumbs-item,
.breadcrumbs-back {
	align-items: center;
	display: flex;
	gap: var(--size-4);
}

.breadcrumbs-list {
	flex-wrap: wrap;
}

.breadcrumbs-item {
	inline-size: fit-content;
}

.breadcrumbs-icon {
	color: var(--c-text-tertiary);
}

.breadcrumbs-link {
	color: var(--c-text-secondary);
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}

	.breadcrumbs-item:last-child & {
		color: var(--c-text-tertiary);
	}
}

@media (width < 68rem) {
	.breadcrumbs-list {
		display: none;
	}
}

@media (width >= 68rem) {
	.breadcrumbs-back {
		display: none;
	}
}
</style>
